import { DispatchDocPage } from "../../../../src/pages/dispatch";
import { TableOfContents, Note } from "src/components";
import { Code, Line, Var } from "@molnx-sites/common/components";
import * as React from 'react';
export default {
  DispatchDocPage,
  TableOfContents,
  Note,
  Code,
  Line,
  Var,
  React
};